import script from "./cguUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./cguUsers.vue?vue&type=script&setup=true&lang=js"

import "./cguUsers.vue?vue&type=style&index=0&id=2fe0549a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fe0549a"]])

export default __exports__